
import React, {useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import TabHeader from '../../components/control/table/tab_header'
import Faq from './faq'
import Term from './term'
import Notice from './notice'
import OneToOne from './one_to_one'
import {rootStore} from '../../mobx/store'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'

const Cs = observer((props) => {
  const location = useLocation();

  const active = 0
  const tabList = [
    strings.notice,
    strings.faq,
    strings.po_terms,
    strings.po_privacy,
    rootStore.getMe != null ? strings.cs : null
  ].filter(Boolean);


  let [tabIndex, setTabIndex] = useState(0)
  let [termIndex, setTermIndex] = useState(0)


  useEffect(() => {
    if (location.state && location.state.tabIndex !== undefined) {
      setTabIndex(location.state.tabIndex);
    }

    if (location.state && location.state.termIndex !== undefined) {
      setTermIndex(location.state.termIndex);
    }
  }, [location.state]);

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft active={active} history={props.history} />
        <div className='im-container'>
          <a className='connect-kakao' href={strings.kakaoOpenLink} target="_blank" rel="noopener noreferrer">
            <img src={'/assets/image/ic-kakao.webp'}></img>
            {strings.kakaoCs}
          </a>
            {tabIndex !== 5 && tabIndex !== 6 && (
                <TabHeader
                  className={'mt-20 sm-none'}
                  selected={tabIndex}
                  tabs={tabList}
                  onChange={(id) => { setTabIndex(id); }}
                />
            )}
            {tabIndex === 0 && <Notice />}
            {tabIndex === 1 && <Faq />}
            {tabIndex === 2 && <Term type={0} />}
            {tabIndex === 3 && <Term type={1} />}
            {tabIndex === 4 && <OneToOne />}
            {tabIndex === 5 && <Term type={2} />}
            {tabIndex === 6 && <Term type={3} />}

        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Cs)
